module.exports = __webpack_public_path__ + "img/derko-long-logo.230665bf.png";